// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"1f07e312","856":"a4c7bff2"}[chunkId] + ".chunk.css";
};